import React from "react";

/**
 * R6 A2 — Sorting state handler.
 * Values in `sortState`: [{ col: "dealership", dir: "asc" }, ...]
 * Cycle on plain click: asc → desc → remove.
 * Shift+click adds a secondary sort.
 */
export function cycleSort(current, columnKey, isShift) {
  const list = Array.isArray(current) ? [...current] : [];
  const idx = list.findIndex((s) => s.col === columnKey);

  if (!isShift) {
    if (idx === -1) return [{ col: columnKey, dir: "asc" }];
    const cur = list[idx];
    if (cur.dir === "asc") return [{ col: columnKey, dir: "desc" }];
    return [];
  }

  if (idx === -1) {
    if (list.length >= 3) return list;
    return [...list, { col: columnKey, dir: "asc" }];
  }
  const cur = list[idx];
  if (cur.dir === "asc") {
    list[idx] = { col: columnKey, dir: "desc" };
    return list;
  }
  return list.filter((_, i) => i !== idx);
}

export function toSortParam(sortState) {
  if (!Array.isArray(sortState) || !sortState.length) return "";
  return sortState.map((s) => `${s.col}:${s.dir}`).join(",");
}

export default function LeadSortMenu({ sortState = [], onSortChange, columns = [] }) {
  return (
    <div className="r6-sort-menu">
      {columns.map((c) => {
        const entry = sortState.find((s) => s.col === c.key);
        const badge = entry ? (entry.dir === "asc" ? "▲" : "▼") : "";
        const idx = entry ? sortState.indexOf(entry) : -1;
        const secondary = entry && idx > 0 ? idx + 1 : null;
        return (
          <button
            key={c.key}
            type="button"
            className={`r6-sort-menu-item ${entry ? "is-sorted" : ""}`}
            onClick={(e) => onSortChange?.(cycleSort(sortState, c.key, e.shiftKey))}
          >
            <span>{c.label}</span>
            {badge && <span className="r6-sort-badge">{badge}{secondary ? ` ${secondary}` : ""}</span>}
          </button>
        );
      })}
    </div>
  );
}